import { z } from "zod";
import { PlatformTypeZ, AdapterTypeZ } from "./platform";

export const FirmMarketTypeZ = z.enum(["forex_cfd", "futures"]);
export type FirmMarketType = z.infer<typeof FirmMarketTypeZ>;

/**
 * A prop firm. First-class config; system handles arbitrary firms via the
 * `/admin/firms/:id/rulebook` route and the `FirmIntelCrawl` workflow.
 */
export const FirmZ = z.object({
  id: z.string().min(1).max(32),
  name: z.string().min(1).max(128),
  platformType: PlatformTypeZ,
  adapter: AdapterTypeZ,
  rulesVersion: z.string().min(1), // e.g. "2026-04-11"
  rulebookHash: z.string().length(64), // sha256 hex — stable Claude cache key
  rawRulebook: z.string(), // full source text (markdown)
  compiledSummary: z.string().nullable(),
  officialUrl: z.string().url().nullable(),
  pfmSlug: z.string().nullable(), // propfirmmatch.com slug if different from our slug
  marketType: FirmMarketTypeZ.default("forex_cfd"),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
});
export type Firm = z.infer<typeof FirmZ>;

/** One chunk of a firm rulebook stored in Vectorize + D1 `rag_chunks`. */
export const RuleChunkZ = z.object({
  id: z.string().min(1),
  category: z.enum(["firm-rules", "news", "trade-history", "account-state", "session-rules"]),
  firmId: z.string().nullable(),
  accountId: z.string().nullable(),
  pairId: z.string().nullable(),
  source: z.enum(["propfirmmatch", "official", "manual"]).default("manual"),
  content: z.string(),
  tokenEst: z.number().int().nullable(),
  createdAt: z.number().int(),
});
export type RuleChunk = z.infer<typeof RuleChunkZ>;
